import { UserRoleE } from "../../../models/enums";
import { SelectOptionT } from "../../../models/models";
import {
  campaignCategoryOptions,
  categoryOptions,
} from "../../../utils/helpers/categoryOptions";

function getSearchCategories(
  isForCampaignsPage: boolean,
  userRole: UserRoleE
): SelectOptionT[] {
  return isForCampaignsPage
    ? campaignCategoryOptions
    : categoryOptions(userRole);
}

export default getSearchCategories;
